import styled from "styled-components";

const StyledInputDateRange = styled.div`
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    row-gap: 0.5rem;
    flex-wrap: wrap;
    border: 1px solid var(--color-grey-2);
    border-radius: 0.25rem;
    padding: 0.5rem;

    >h3 {
        font-weight: 500;
        font-size: 0.875rem;
    }
`;

export default StyledInputDateRange;